import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
  Stack,
  Divider,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import userAPI from "../../Services/Admin/userAPI";
import PersonIcon from "@mui/icons-material/Person";
import BorderAllIcon from "@mui/icons-material/BorderAll";

const UserProfil = ({ userId }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fonction pour formater les dates
  const formatDate = (dateObj) => {
    if (!dateObj || !dateObj.date) return "Date inconnue"; // Vérifie si l'objet de date est valide
    return dayjs(dateObj.date).format("DD.MM.YY"); // Formate la date au style souhaité
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const data = await userAPI.getUserById(userId);
        setUser(data.data);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des données utilisateur :",
          error
        );
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Typography variant="h6" color="error">
          Aucune donnée utilisateur trouvée.
        </Typography>
      </Box>
    );
  }

  return (
    <Card
      sx={{
        maxWidth: 1200,
        margin: "auto",
        padding: 2,
        backgroundColor: "transparent",
        boxShadow: "none",
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }} padding={2} backgroundColor="#fff">
            <Stack
              direction="column"
              spacing={2}
              sx={{
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ width: 80, height: 80, bgcolor: "#9C27B0" }}>
                <PersonIcon sx={{ fontSize: 60 }} />
              </Avatar>
              <Typography variant="h6">
                {user.firstname.charAt(0).toUpperCase() +
                  user.firstname.slice(1).toLowerCase()}{" "}
                {user.lastname.charAt(0).toUpperCase() +
                  user.lastname.slice(1).toLowerCase()}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {user.speciality}
              </Typography>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 8 }} padding={2} backgroundColor="#fff">
            <Box>
              <Typography variant="h6" gutterBottom>
                Années de formation
              </Typography>
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
              >
                {user.years.map((year) => (
                  <React.Fragment key={year.id}>
                    <ListItem
                      alignItems="flex-start"
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete">
                          <BorderAllIcon sx={{ color: "#9C27B0" }} />
                        </IconButton>
                      }
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            fontSize: "1rem",
                            backgroundColor: "#9C27B0",
                            color: "white",
                          }}
                        >
                          {year.yearOfFormation}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={year.master}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{ color: "text.primary", display: "inline" }}
                            >
                              {formatDate(year.dateOfStart)}{" "}
                              {/* Conversion correcte */}
                            </Typography>
                            {` — ${year.hospital}`}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 4,
          }}
        >
          <Box textAlign="center">
            <Typography variant="h6">{user.tasksDone || 0}</Typography>
            <Typography variant="body2" color="text.secondary">
              Tasks Done
            </Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="h6">{user.projectsDone || 0}</Typography>
            <Typography variant="body2" color="text.secondary">
              Projects Done
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UserProfil;
